<template>
  <div>
    <va-modal
      :value="show"
      id="cloningSelectionModal"
      size="medium"
      :noOutsideDismiss="false"
      :okText="$t('iframe.actions.clone')"
      :cancelText="$t('users.cancel')"
      @ok="onClickOk"
      @cancel="onClickCancel"
      :okDisabled="!selectedCloningMode">
      <div slot="header" class="modal-title">
        {{$t('iframe.titles.cloning_mode_title')}}
      </div>

      <div>
        <b>
          {{$t('iframe.titles.cloning_mode_body')}}
        </b>
      </div>
      <div class="row">
        <div class="col-12">
          <label class="form-label">
            {{$t('iframe.titles.cloning_mode_title')}}
          </label>
          <multiselect
            id="cloning-mode-multiselect"
            v-model="selectedCloningMode"
            :options="cloningOptions"
            track-by="id"
            label="label"
            placeholder="---"
            :allow-empty="false"
            :multiple="false"
            :close-on-select="true"
          >

          </multiselect>
        </div>
      </div>

    </va-modal>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect'
export default {
  components: {
    Multiselect
  },
  data() {
    return {
      show: false,
      selectedCloningMode: null,
      cloningOptions: [
        {
          id: 0,
          label: this.$t('iframe.titles.deep')
        },
        {
          id: 1,
          label: this.$t('iframe.titles.shallow')
        }
      ]
    }
  },
  mounted() {
    this.show = true
  },
  methods: {
    onClickOk: function () {
      this.$emit('confirm', this.selectedCloningMode)
    },
    onClickCancel: function () {
      this.$emit('cancel')
    }
  }
}
</script>

<style scoped>

</style>
